export { default } from "./useTeacherLanguageMutation";
